<template>
  <div class="categoria-form">
    <form @submit.prevent="guardarCategoria" class="categoria-form__body">
      <div class="categoria-form__group">
        <label class="categoria-form__label">
          Nombre de la categoría
        </label>
        <input
          v-model="nombre"
          type="text"
          placeholder="Ej. Laptops"
          class="categoria-form__input"
        />
        <p v-if="error" class="categoria-form__error">
          {{ error }}
        </p>
      </div>

      <div class="categoria-form__footer">
        <button
          type="submit"
          class="categoria-form__btn categoria-form__btn--primary"
        >
          Guardar
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'FormularioCategoria',
  emits: ['categoriaAgregada', 'finalizarCreacionCategoria'],
  data() {
    return {
      nombre: '',
      error: '',
    };
  },
  methods: {
    async guardarCategoria() {
      this.error = '';

      const nombreLimpio = (this.nombre || '').trim();

      // Validación local (sin toast)
      if (!nombreLimpio) {
        this.error = 'El nombre es obligatorio.';
        return;
      }

      try {
        const res = await axios.post('/api/almacen/categorias/crear', {
          nombre: nombreLimpio,
        });

        if (res.data?.status === 'ok') {
          // Éxito: limpiamos y notificamos
          this.nombre = '';
          this.error = '';

          // Toast de éxito
          this.$toast?.success('Categoría creada correctamente.');

          this.$emit('categoriaAgregada');
          this.$emit('finalizarCreacionCategoria');
        } else {
          const mensajeError =
            res.data?.message || 'No se pudo guardar la categoría.';
          this.error = mensajeError;
          // Toast de error (sin cerrar nada)
          this.$toast?.error(mensajeError);
        }
      } catch (err) {
        console.error('Error al guardar categoría:', err);
        const mensajeError = 'Error al guardar categoría.';
        this.error = mensajeError;
        // Toast de error (sin cerrar nada)
        this.$toast?.error(mensajeError);
      }
    },
  },
};
</script>


<style scoped lang="scss">
.categoria-form {
  width: 100%;
}

.categoria-form__body {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.categoria-form__group {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.categoria-form__label {
  font-size: 0.8rem;
  color: #cbd5f5;
}

.categoria-form__input {
  width: 100%;
  border-radius: 0.8rem;
  border: 1px solid rgba(148, 163, 184, 0.8);
  background: rgba(15, 23, 42, 0.9);
  padding: 0.45rem 0.7rem;
  font-size: 0.85rem;
  color: #e5e7eb;
  outline: none;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.9);
  transition:
    border-color 0.16s ease,
    box-shadow 0.16s ease,
    background 0.16s ease;
}

.categoria-form__input::placeholder {
  color: #6b7280;
}

.categoria-form__input:focus {
  border-color: rgba(129, 140, 248, 0.95);
  background: rgba(15, 23, 42, 0.98);
  box-shadow:
    0 0 0 1px rgba(129, 140, 248, 0.7),
    0 0 0 1px rgba(15, 23, 42, 1);
}

.categoria-form__error {
  font-size: 0.75rem;
  color: #fca5a5;
}

/* Footer */
.categoria-form__footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.1rem;
}

.categoria-form__btn {
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.8rem;
  padding: 0.35rem 0.95rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    box-shadow 0.18s ease,
    transform 0.08s ease;
}

.categoria-form__btn--primary {
  background: #e5e7eb;
  color: #020617;
}

.categoria-form__btn--primary:hover {
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.95);
}
</style>
